var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlomberie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.038 20.2448L177.628 33.8547L91.9176 83.3247L83.3175 101.915L71.5276 163.175L47.9375 149.555V95.1047C47.9375 90.8147 49.0875 86.7747 51.0975 83.3147C53.0875 79.8847 55.9075 77.0047 59.2975 74.9447C59.6175 74.7447 59.9476 74.5548 60.2776 74.3748L154.038 20.2448Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3175 101.915L71.5276 163.175L47.9375 149.555V95.1051C47.9375 90.8151 49.0875 86.7751 51.0975 83.3151",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.628 33.8551V61.0751L115.518 96.9451L95.1075 108.725V149.555L71.5276 163.175V108.725C71.5276 104.425 72.6775 100.395 74.6875 96.9252C76.6775 93.5052 79.4976 90.6251 82.8876 88.5651C83.2076 88.3551 83.5376 88.1651 83.8676 87.9951L177.628 33.8551Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.608 210.815L154.038 224.415V74.6948L177.628 61.0748L177.608 210.815Z",
    fill: "#29A063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.408 231.225L159.938 214.215V186.995L189.408 203.995V231.225Z",
    fill: "#B2E8C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205.047 194.965L174.668 178.955L159.938 186.995L189.408 203.995L205.047 194.965Z",
    fill: "#72D09A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.358 189.645L180.418 186.665L200.018 197.865L194.328 201.025L175.358 189.645Z",
    fill: "#29A063"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.358 200.515L106.888 183.505V156.285L136.358 173.285V200.515Z",
    fill: "#B2E8C5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.468 152.525L121.618 147.855L106.888 156.285L130.468 169.975V152.525Z",
    fill: "#72D09A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M112.778 152.985L117.208 150.455L133.638 159.305L132.378 164.365L112.778 152.985Z",
    fill: "#29A063"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M154.038 224.425L130.468 210.815V88.3049L154.047 74.6949V224.425H154.038Z",
    fill: "#B2E8C5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.048 222.185L189.408 231.225V203.995L205.048 194.965V222.185Z",
    fill: "#29A063"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7876 164.905C66.4376 166.845 65.3475 167.475 60.9975 169.975C53.3475 182.955 52.0276 211.855 72.7776 217.615C76.7376 215.335 78.2675 214.355 80.6175 213.085C90.8275 207.625 79.5476 180.885 69.7776 164.905H69.7876Z",
    fill: "#F97E73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9975 169.975C48.9775 182.265 31.8875 210.395 60.9775 218.455C87.1575 225.715 73.0175 189.645 60.9975 169.975Z",
    fill: "#FECECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlomberie);
export default __webpack_public_path__ + "static/media/plomberie.c294f934726c47484c0abb6811fd93ce.svg";
export { ForwardRef as ReactComponent };